import React from 'react';

// Small building blocks for the results surfaces, on the v2 ("Tell-tale") classes in
// public/design/v2/site.css. No inline colours: see docs/brand/DESIGN.md.

const cx = (...names) => names.filter(Boolean).join(' ');

// Surface — a v2 card. tone="emphasis" gives the best option its 2px ink border.
export function Surface({ tone = 'default', className, children, ...rest }) {
  return (
    <div className={cx('vc-card', tone === 'emphasis' && 'vc-card--best', className)} {...rest}>
      {children}
    </div>
  );
}

// MetricTile — a bento metric, drawn as a reading with no gauge.
export function MetricTile({ label, value, sub, className, ...rest }) {
  return (
    <div className={cx('vc-reading', className)} {...rest}>
      <div className="vc-reading__body">
        {label && <div className="vc-reading__label">{label}</div>}
        {value !== undefined && <div className="vc-reading__value">{value}</div>}
        {sub && <div className="vc-reading__note">{sub}</div>}
      </div>
    </div>
  );
}

// Pill — a chip. tone="info" is the blue information chip, "good" the green status
// chip; "neutral" is ink on tint.
const PILL_TONES = { info: 'vc-chip--info', good: 'vc-chip--good', neutral: 'vc-chip--plain' };

export function Pill({ tone = 'neutral', className, children, ...rest }) {
  return (
    <span className={cx('vc-chip', PILL_TONES[tone], className)} {...rest}>
      {children}
    </span>
  );
}
